export default function (ctx) {
    ctx.$axios.onError((error) => {
        const code = parseInt(error.response && error.response.status)

        if (code === 401 && ctx.$auth.loggedIn) {
            ctx.$auth.logout()
        }
    })
}
